import React, { useEffect, useState } from "react";
import RegisterMachine from "./RegisterMachine";
import Login from "./Login";
import SomethingWentWrong from "./SomethingWentWrong";
import "../css/StartingPage.css";
import LoadingLayout from "./LoadingLayout";
import axios from "axios";
import { checkValidityOfMachine } from "../utils/checkIsMachineValid";

function StartingPage() {

  const [showSomethingWentWrongState, setShowSomethingWentWrongState] = useState(false)
  const [showRegisterMachineState, setShowRegisterMachineState] = useState(false);
  const [showLoginState, setShowLoginState] = useState(false);
  const [loadingScreenStartingPageState, setLoadingScreenStartingPageState] = useState(false);

  

  const checkingInStartPage = async () => {

    setLoadingScreenStartingPageState(true);

    let currentLocalValues = localStorage.getItem("current_machineguid");

    if (currentLocalValues) {

      let resultOfChecking = await checkValidityOfMachine();

      console.log("resultOfChecking -->",  resultOfChecking);

      if (resultOfChecking == true) {

        setLoadingScreenStartingPageState(false);
        showLoginPageScreen()

      } else if (resultOfChecking == false) {

        setLoadingScreenStartingPageState(false);
        showRegistrationPageScreen()

      } else if (resultOfChecking == null) {
        setLoadingScreenStartingPageState(false);
        showSomethingWentWrong()
      }

    } else {

      // 2 commented this because to avoid registration for demo just go straight to login page

      console.log("currentLocalValues null ");

      setLoadingScreenStartingPageState(false);
      showRegistrationPageScreen();
    }
  }

  useEffect(() => {


    checkingInStartPage()


  }, []);

  const showLoginPageScreen = () => {
    // console.log("showLoginPageScreen called ");
    setShowRegisterMachineState(false);
    setShowLoginState(true);
  };

  const showRegistrationPageScreen = () => {
    // console.log("showRegistrationPage called ");
    setShowLoginState(false);
    setShowRegisterMachineState(true);
  };

  const showSomethingWentWrong = () => {
    setShowSomethingWentWrongState(true)
  }

  return (
    <div>
      {showRegisterMachineState && (
        <RegisterMachine
          showLoginPageAfterRegistration={showLoginPageScreen}
        />
      )}

      {showLoginState && <Login showRegistrationPage={showRegistrationPageScreen} />}


      {showSomethingWentWrongState && <SomethingWentWrong />}


      {loadingScreenStartingPageState &&
        <LoadingLayout />
      }

    </div>
  );
}

export default StartingPage;
